export const onboardingKeys = {
  all: ["onboarding"] as const,
  state: ["onboarding", "state"] as const,
};
